const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

export default {
  // baseUrl: "http://192.168.18.21:7000/",
  // baseUrl: "https://ec2-18-116-175-124.us-east-2.compute.amazonaws.com:8005/",

  // ==============  new base urrl ============
  // baseUrl: "https://backend.sellanywheel.com/",
  // baseUrl: "https://backend.sellanywheel.com:7000/",

  baseUrl: "https://carsapi.saldr.tech/",
  // baseUrl: "http://192.168.18.18:8000/",
  clientWebUrl:
    process.env.REACT_APP_CLIENT_WEB_URL ||
    (isLocalHost ? "http://localhost:3000" : "https://www.autotradeport.com"),
};
